module.exports = __webpack_public_path__ + "img/Weapon_205.f075bcf0.png";